import { MessageDTO } from "@/contexts/MessagesContext/types";

export const extractDataFromMessages = (messages: MessageDTO[]) => {
  const lastMessage = messages[messages.length - 1];
  if (lastMessage && lastMessage.actions?.length) {
    return lastMessage.actions[0];
  }
  return undefined;
};
